import { render } from "./m_about.vue?vue&type=template&id=7bb3db9a&scoped=true"
import script from "./m_about.vue?vue&type=script&lang=js"
export * from "./m_about.vue?vue&type=script&lang=js"

import "./m_about.vue?vue&type=style&index=0&id=7bb3db9a&scoped=true&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bb3db9a"]])

export default __exports__